"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _core = require("@material-ui/core");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var useStyles = (0, _core.makeStyles)(function (theme) {
  return {
    appBar: {
      boxShadow: "0 2px 8px ".concat((0, _core.fade)(theme.palette.common.black, 0.16))
    },
    appBarDrawer: {
      zIndex: theme.zIndex.drawer + 1
    },
    toolbar: {
      justifyContent: "space-between",
      minHeight: theme.spacing(9)
    }
  };
});

var AppBar = function AppBar(_ref) {
  var _classNames;

  var children = _ref.children,
      drawerIsOpen = _ref.drawerIsOpen,
      position = _ref.position;
  var styles = useStyles();
  return /*#__PURE__*/_react.default.createElement(_core.AppBar, {
    elevation: 0,
    position: position,
    color: "inherit",
    className: 'header ' + (0, _classnames.default)((_classNames = {}, _defineProperty(_classNames, styles.appBar, true), _defineProperty(_classNames, styles.appBarDrawer, drawerIsOpen), _classNames))
  }, /*#__PURE__*/_react.default.createElement(_core.Toolbar, {
    className: styles.toolbar
  }, children));
};

AppBar.propTypes = {
  drawerIsOpen: _propTypes.default.bool,
  position: _propTypes.default.string,
  children: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.node])
};
AppBar.defaultProps = {
  drawerIsOpen: false,
  position: "sticky",
  children: null
};
var _default = AppBar;
exports.default = _default;